import moment from 'moment';
import { createReducer } from 'typesafe-actions';
import withJobs from '../../_core/job/reducers';
import {
    IORB4Store,
} from './@types';
import orb4Actions, { EORB4Constants, TORB4Actions } from './actions';

const defaultState: IORB4Store = {
    _jobs: {},
    currentOperation: undefined,
    records: {
        byIds: {},
        ids: [],
    },
    filter: {
        startDate: moment().subtract(7, 'days').toDate(),
        endDate: moment().add(1, 'day').toDate(),
        shownRecords: 'ALL',
		vesselId: ''
    },
};
const orb4Reducers = createReducer<IORB4Store, TORB4Actions>(defaultState)
    .handleAction(
        orb4Actions.document.historySet,
        function historySet(state, action) {
            return {
                ...state,
                records: action.payload.history,
            };
        }
    )
    .handleAction(
        orb4Actions.document.setFilter,
        function setFilter(state, action) {
            return {
                ...state,
                filter: action.payload.filter,
            };
        }
    );

export default withJobs<IORB4Store>(
    EORB4Constants.FEATURE,
    defaultState,
    orb4Reducers
);
